module.exports = __webpack_public_path__ + "img/audi3.f989d7f6.jpg";